// extracted by mini-css-extract-plugin
module.exports = {"modal-container":"modal-container___2BXsF","header":"header___1QwQ-","body":"body___2pWtt","footer":"footer___1qe5J"};